// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardPageContainer_container__FxVC7","admin_side_menu_container":"DashboardPageContainer_admin_side_menu_container__84xPC"};